import { BsFillCheckCircleFill } from "react-icons/bs";

export interface ComplaintTypeSelectProps {

    text: string;
    onPress: () => void;
    isSelected: boolean;

}

const ComplaintTypeSelect = ({ text, onPress, isSelected }: ComplaintTypeSelectProps) => {

    return (
        <>
            {isSelected
                ?
                <div onClick={onPress} style={{ padding: "0.5rem", alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "space-between", backgroundColor: "#8080802b", height: "3rem" }}>
                    <div>{text}</div>
                    <BsFillCheckCircleFill color={"#e62563"} />
                </div>
                :
                <div onClick={onPress} style={{ padding: "0.5rem", alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "space-between", height: "3rem" }}>
                    <div>{text}</div>
                </div>
            }
        </>
    )
}

export default ComplaintTypeSelect;